import jsSIP from 'jssip'
import constants from '../utils/constants'

const socket = new jsSIP.WebSocketInterface(constants.CACOFONIX_WSS)
socket.via_transport = 'WSS'

const configuration = {
  sockets: [socket],
  registrar_server: constants.SIP_DOMAIN,
  realm: constants.SIP_DOMAIN,
  register: true,
}

const setCredentials = (username, password) => {
  const uri = `sip:${username}@${constants.SIP_DOMAIN}`
  configuration.uri = uri
  configuration.username = username
  configuration.password = password
  configuration.contact_uri = uri
  configuration.authorization_user = username
  configuration.display_name = username
}

export { setCredentials, configuration }
